import {observable, action, runInAction, computed, toJS} from 'mobx';
import BasePaginationStore from '@store/Common/BasePaginationStore';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import { server_address } from '@src/env-config';
import {message} from "antd";

import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import MyAgentStore from '@store/LoginUser/MyAgentStore';


class Item {
  constructor(data) {
    this.init(data);
  }

  @action
  init(data) {
    if (data == undefined) {
      return
    }

    for(let attr in data) {
      this[attr] = data[attr];
    }
  }

  @observable
  id;

  @observable
  pet_name;

  @observable
  nick_name;

  /**
   * 方案号
   */
  @observable
  number;

  /**
   * 投注金额
   */
  @observable
  out_amount;

  /**
   * 分成金额
   */
  @observable
  yon_money;

  /**
   * 分成比例
   */
  @observable
  proxy_radio;

  @computed
  get get_radio(){
    return (Number(toJS(this.proxy_radio))).mul(100).toFixed(2)+'%';
  }

  @observable
  is_add;

  /**
   * 是否合买
   */
  @observable
  is_community;

  @observable
  is_copy;

  @observable
  is_daigou;

  @observable
  is_optimization;

  /**
   * 是否追号
   */
  @observable
  is_zhuihao;

  /**
   * 订单号
   */
  @observable
  order_id;

  /**
   * 玩法类型
   */
  @observable
  play_type;

  /**
   * 开奖结果
   */
  @observable
  result;

  /**
   * 出票结果
   */
  @observable
  status;

  /**
   * 期号
   */
  @observable
  term_no;

  /**
   * 投注时间
   */
  @observable
  build_time;

  /**
   * 彩票类型
   */
  @observable
  type;

  /**
   * 中奖金额
   */
  @observable
  win_money;

  /**
   * 嘉奖彩金
   */
  @observable
  mosaic_win_money;

}

class PaginationStore extends BasePaginationStore {

}

/**
 * 页面头部筛选过滤器字段值
 */
class FilterStore {

  //是否初始化过
  is_init;

  search;

  type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_AGENT_ALL);
  //代理昵称
  agent;
  //代理id
  id;
  type_time

  @action
  setAttr({agent,search,type,id,type_time}) {

    this.resetAttr();


    this.search = search;
    if (type == undefined)
    {
      this.type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_AGENT_ALL);
    }
    else
    {
      this.type = type;
    }

    if (agent != undefined || agent != '')
    {
      this.agent = agent;
      this.id = MyAgentStore.findMyAgentId(agent);
    }

    this.type_time = type_time;
    this.is_init = true;
  }

  getAttr() {
    return {
      search: this.search,
      type: this.type,
      id: this.id,
      type_time: this.type_time
    }
  }

  setDefault(type) {
    this.resetAttr();
    this.type = 2;
    this.is_init = true;
  }


  @action
  resetAttr() {
    this.search = undefined;
    this.type = undefined;
    this.id = undefined;
    this.type_time = 6;
    this.agent = undefined;
    this.is_init = undefined;
  }
}

let filter_store = new FilterStore();

class ItemStore {

  constructor(pagination) {
    this.init(pagination);
  }

  @action
  init(pagination){
    this.pagination_store = pagination;
  }

  @observable
  item_map = new Map();

  @observable
  pagination_store;


  @observable
  summoney = 0;

  /**
   *  item数组列表
   */
  @computed
  get item_array() {
    let res = [];
    this.item_map.forEach((values, key) => {
      res.push(values);
    });
    return res;
  }

  /**
   * 编辑中的 item
   */
  @observable
  editting_item = new Item();

  /**
   * 控制编辑 modal 是否显示
   */
  @observable
  is_edit_modal_show = true;

  /**
   * 打开 modal 显示
   */
  @action
  openEditModal() {
    this.is_edit_modal_show = true;
  }

  /**
   * 关闭 modal 显示
   */
  @action
  closeEditModal() {
    this.editting_item = new Item();
    this.is_edit_modal_show = false;
  }

  @action
  reloadDatas( filter ) {
    //由于立马清除item_map会导致expand无法收回
    // this.item_map.clear();
    this.new_num = 0;
    this.new_total = 0;
    this.pagination_store.clear();

    if (filter == undefined)
    {
      if (filter_store.is_init == undefined)
      {
        filter_store.setDefault()
      }
    }
    else
    {
      filter_store.setAttr(filter);
    }

    this.searchByFilter({
      desc: '1',
      order: "build_time"
    });

  }

  /**
   * 根据条件搜索 item
   * @param {*} page_opts
   */
  async searchByFilter(page_opts){
    let page_option = {
      page: this.pagination_store.page_cur,
      page_size: this.pagination_store.page_size,
      ...filter_store.getAttr(),
      ...page_opts
    }
    let res = await this._getItemArray(page_option);
    return res;
  }

  /**
   * 获取 item列表
   */
  async _getItemArray(page_option = {}) {
    let url = fetchUrl.admin.orderList;
    let res = await service.fetchData({
      path: url,
      params: {
        ...page_option
      }
    });
    service.responseHandle({
      res: res,
      success_handle: (res) => {
        runInAction(() => {
          // console.log(res);
          this.item_map.clear();
          res.data.data.forEach((item, index) => {
            item.id=item.order_id;
            this.item_map.set(item.id, new Item(item));
          });
          this.pagination_store.setAttr(res.data.page);
          this.summoney = res.data.summoney;
        })
      },
      fail_handle: (res) => {
        message.error(res.error.error_data,3);
        this.pagination_store.clear()
        filter_store.resetAttr();
        this.item_map.clear();
      }
    });
    return res;
  }
}

let pagination_store = new PaginationStore();
let item_store = new ItemStore(pagination_store);

export {
  pagination_store,
  filter_store
}
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Statistic/MyRakeBack/MyRakeBackStore.js